<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'COMPANY_DETAILS.GENERAL_TAB_LABEL' | translate }}</h3>
    </div>

    <div class="sp-row__align">
      <h5 class="sp-color__primary sp-margin__right">{{ getCompanyStatusLabel() | translate }}</h5>
      <div
        class="sp-circle__xs sp-margin__right"
        [matTooltip]="getCompanyStatusLabel() | translate"
        [ngClass]="getCompanyStatusBackgroundClass()"></div>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x4 sp-company-details-general-info__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info-copy
      [label]="'COMPANIES.ID_COLUMN_LABEL'"
      [content]="company?.company_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'COMPANIES.REGISTRATION_DATE_LABEL'"
      [content]="(company?.created_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'STORES.BUSINESS_NAME_LABEL'"
      [content]="getCompanyName()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'STORES.VAT_LABEL'"
      [content]="company?.vat || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'GENERAL.TAX_CODE'"
      [content]="company?.tax_code || company?.vat || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'COMPANIES.PRODUCT_CATEGORY'"
      [content]="getCompanyProductCategoryLabel()"
      [is_update_enabled]="true"
      (update_click)="onSetProductCategoryClick()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'STORES.SALES_CHANNEL'"
      [content]="getCompanySalesChannelLabel()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'COMPANIES.SALES_NETWORK_ID_LABEL'"
      [content]="company?.sales_network_id || '-'"
      [is_update_enabled]="isSalesNetworkIDEditable()"
      (update_click)="onSetSalesNetworkIdClick()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info-copy
      [label]="'STORES.OWNER_ID_LABEL'"
      [content]="company?.owner_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'STORES.OWNER_EMAIL_LABEL'"
      [content]="company?.owner_email || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'STORES.OWNER_NAME_LABEL'"
      [content]="getOwnerFullName()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'STORES.REVENUES_LABEL'"
      [content]="getRevenuesRange()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'STORES.WEBSITE_LABEL'"
      [content]="company?.website || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'COMPANIES.ALLOWED_DOMAINS_CTA'"
      [content]="getAllowedDomain()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'COMPANIES.ORIGIN_COLUMN_LABEL'"
      [content]="getCompanyOriginLabel()"
      [is_update_enabled]="true"
      (update_click)="onSetOriginClick()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      *ngIf="company?.status === 'archived'"
      [label]="'COMPANIES.ARCHIVED_BY_LABEL'"
      [content]="company?.archived_by || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      *ngIf="company?.status === 'archived'"
      [label]="'COMPANIES.ARCHIVED_NOTE_LABEL'"
      [content]="getArchivedNote()"
      [is_update_enabled]="false"
      (update_click)="onSetArchivedNoteClick()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'COMPANIES.SALES_REFERENCE_EMAIL_LABEL'"
      [content]="company?.sales_reference_email || '-'"
      [is_update_enabled]="true"
      (update_click)="onSetSalesReferenceEmailClick()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'COMPANIES.CUSTOM_WHITE_LABEL_DOMAIN_CTA'"
      [content]="company?.custom_buyer_subdomain || '-'"
      [is_update_enabled]="true"
      (update_click)="onSetCustomDomainClick()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'COMPANIES.STAND_BY_NOTE_DIALOG_TITLE'"
      [content]="getNotes()"
      [is_update_enabled]="true"
      (update_click)="onSetNotesClick()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
</div>
